import core_viz from './core-viz';
import routine from './routine';
import lang from './lang';

//cv dropdown html
const cv_dropdown = $('.cv-dropdown'),
	cv_dropdown_selected = cv_dropdown.find('.cv-dropdown__selected'),
	cv_dropdown_selected_text = cv_dropdown_selected.find('p'),
	cv_dropdown_content = cv_dropdown.find('.cv-dropdown__content'),
	cv_dropdown_content_text = cv_dropdown_content.find('p');


// select2 dropdowns
const dropdownIDs = ['dropdown-habit', 'dropdown-coping'];

const dataSources = {
	'habit': [{
		id: 'Guilt',
		text: 'Guilt',
	}, {
		id: "It's the best part of my day",
		text: "It's the best part of my day"
	}, {
		id: 'Meeting a friend or group',
		text: 'Meeting a friend or group'
	}, {
		id: 'Checking it off my to-do list',
		text: 'Checking it off my to-do list'
	}, {
		id: 'Post-run reward',
		text: 'Post-run reward'
	}, {
		id: 'Have a workout plan',
		text: 'Have a workout plan'
	}],
	'coping': [{
		id: 'Lost a loved one',
		text: 'Lost a loved one'
	}, {
		id: 'Moved to a new city or country',
		text: 'Moved to a new city or country'
	}, {
		id: 'Got married',
		text: 'Got married'
	}, {
		id: 'Separated or divorced',
		text: 'Separated or divorced'
	}, {
		id: 'Had or adopted a child',
		text: 'Had or adopted a child'
	}, {
		id: 'Diagnosed or received treatment for a significant illness',
		text: 'Diagnosed or received treatment for a significant illness'
	}, {
		id: 'Lost my job',
		text: 'Lost my job'
	}, {
		id: 'Started a new job',
		text: 'Started a new job'
	}, {
		id: 'Retired',
		text: 'Retired'
	}]
}

function init() {
	return new Promise((resolve, reject) => {
		activateCV();
		activateSelect2();
		resolve();
	})
}

function activateSelect2() {
	const currentLang = lang.getCurrentLang();
	if (currentLang !== 'en-US') {
		dataSources.habit = dataSources.habit.filter(d => d.id !== 'Checking it off my to-do list');
	}

	dataSources.coping.forEach(d => {
		d.text = lang.translateViz('routine', `Coping--${d.id}`);
	})

	dataSources.habit.forEach(d => {
		d.text = lang.translateViz('routine', `Habit--${d.id}`);
	})

	dropdownIDs.forEach((id) => {
		$(`#${id}`).each(function() {
			$('select', this).select2({
				placeholder: lang.translateViz('routine', `${$(this).attr('data-placeholder')}`),
				minimumResultsForSearch: -1,
				dropdownCssClass: 'routine-dropdown-style',
				//allowClear: true,
				data: dataSources[$(this).attr('data-source')],
				width: 200,
				height: 30,
			});
		})

		// add functions here
		$(`#${id}`).on('select2:open', function(params) {
				//console.log('here');

			})
			.on('select2:select', function(e) {
				const value = e.params.data.id;
				d3.select(`#${id}`).select('.select2-selection__rendered').classed('is-active', true);
				updateSelect2(id, value);
			})
	})
}

function updateSelect2(id, value) {
	routine.addHighlightColor();
	if (id === 'dropdown-habit' || id === 'lang-dropdown-habit') routine.filter(null, ['Big goals', 'Habit', value]);
	if (id === 'dropdown-coping' || id === 'lang-dropdown-coping') routine.filter(null, ['Children left home', 'Experienced a significant injury', value]);
}

function clearSelect2() {
	dropdownIDs.forEach(id => {
		d3.select(`#${id}`).select('.select2-selection__rendered').classed('is-active', false)
		$(`#${id} select`).val('').trigger('change');
	})
}

function activateCV() {
	cv_dropdown_content.click(function() {
		const selected = cv_dropdown_content_text.text();

		toggleCV(selected, true);
		//cv_dropdown_content.css('display', 'none');
	})
}

function toggleCV(selected, active = false) {
	const current = selected === lang.translateViz('cv', 'Dropdown--Started') ? lang.translateViz('cv', 'Dropdown--Continue') : lang.translateViz('cv', 'Dropdown--Started');

	cv_dropdown_selected_text.text(selected);
	cv_dropdown_content_text.text(current);

	const status = selected === lang.translateViz('cv', 'Dropdown--Started') ? 'start' : 'now';
	core_viz.filter(null, null, null, status)

	cv_dropdown_selected.toggleClass('is-active', active)
}

export default {
	init,
	toggleCV,
	clearSelect2,
};